import React from 'react'
import { useStyletron } from '../../../theme'

export default function SelectArrow({
    $disabled,
    $error,
    $isOpen
}: {
    $disabled: boolean
    $error: boolean
    $isOpen: boolean
}) {
    const [css, theme] = useStyletron()
    const openIcon = 'wemolo-chevron-down'
    const closeIcon = 'wemolo-chevron-up'
    const iconClassName = $isOpen ? closeIcon : openIcon

    return (
        <i
            className={`${iconClassName} ${css({
                fontSize: theme.sizing.scale600,
                cursor: 'pointer',

                ...($disabled && {
                    color: theme.colors.mono300,
                    cursor: 'not-allowed'
                })
            })}`}
        />
    )
}
